<template>
  <div class="dialog-department-edit">
    <Form :model="formData" :label-width="120" ref="editDepartmentForm" :rules="validateRules">
      <FormItem label="姓名：" prop="name">
        <Input v-model="formData.name" placeholder="请输入姓名"></Input>
      </FormItem>
       <FormItem label="手机号：" prop="mobile">
        <Input :maxlength= '18' v-model="formData.mobile" placeholder="请输入手机号"></Input>
      </FormItem>
      <FormItem label="证件类型：" prop="idCardType">
        <Select v-model="formData.idCardType" filterable>
          <Option v-for="option in cardList" :value="option.code" :key="option.code">{{option.name}}</Option>
        </Select>
      </FormItem>
      <FormItem label="证件号码：" prop="identityCard">
        <Input v-model="formData.identityCard" placeholder="请输入证件号码"></Input>
      </FormItem>
      <FormItem label="单位名称：" prop="schoolId">
        <Select v-model="formData.schoolId" filterable @on-change="changeSchool">
          <Option v-for="(option, index) in schoolList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
      </FormItem>
<!--      <FormItem label="送审级别" prop="ssdwLevel">
        <Select v-model="formData.ssdwLevel" @on-change="changeLevel">
          <Option value="1">一级</Option>
          <Option value="2" v-if="parentList.length>0">二级</Option>
        </Select>
      </FormItem>-->
      <FormItem v-if="formData.ssdwLevel=='2'" label="所属学院：" prop="department">
        <Input v-model="formData.department" placeholder="请输入所属学院"></Input>
      </FormItem>
      <FormItem v-if="formData.ssdwLevel=='2'" label="上级联系人：" prop="superiorUserId">
        <Select v-model="formData.superiorUserId">
          <Option v-for="option in parentList" :key="option.userId" :value="option.userId">{{option.name}}</Option>
        </Select>
      </FormItem>
    </Form>
    <Spin size="large" fix v-if="formLoading"></Spin>
  </div>
</template>

<script>
/* global FormItemRules:true */
export default {
  props: {
    query: ''
  },
  data () {
    const isPHONE = (rule, value, callback) => {
      if (value) {
        if (!this.formDefaultRules.isPHONE.test(value)) {
          return callback(new Error('输入的手机号不符合规则'));
        }
      }
      return callback();
    };
    return {
      validateRules: {
        name: [{required: true, message: '请填写姓名', trigger: 'blur'}],
        mobile: [{required: true, message: '请填写手机号', trigger: 'blur'}, {validator: isPHONE, trigger: 'blur'}],
        idCardType: [{required: true, message: '请选择证件类型', trigger: 'change'}],
        identityCard: [{required: true, message: '请填写证件号码', trigger: 'blur'}],
        schoolId: [{required: true, message: '请选择单位', trigger: 'change'}],
        ssdwLevel: [{required: true, message: '请选择送审级别', trigger: 'change'}],
        department: [{required: true, message: '请填写所属学院', trigger: 'blur'}],
        superiorUserId: [{required: true, message: '请选择上级联系人', trigger: 'blur'}]
      },
      formData: {},
      defaultData: {},
      parentList: [],
      schoolList: [],
      cardList: [],
      formLoading: true
    }
  },
  created () {
    this.formDefaultRules = FormItemRules;
    if (this.query) {
      this.initOptionList()
      this.fetchUserMsg();
    } else {
      this.initOptionList()
      this.formLoading = false
    }
  },
  methods: {
    initOptionList () {
      this.fetchSchoolList()
      this.fetchCardList()
    },
    async fetchSchoolList () {
      let param = {
        query: {},
        page: {
          currPage: 1,
          pageSize: 10000
        }
      };
      let res = await this.post('/school/school/list', param)
      this.schoolList = res.data.list // 单位名称
    },
    changeSchool (schoolId, init) {
      this.parentList = [];
      if (!init) {
        this.formData.superiorUserId = null;
      }
      // if (schoolId) {
      //   this.fetch('/sys/department/superiors/' + schoolId).then(res => {
      //     // 获取上级联系人
      //     for (let item of res.data) {
      //       // 上级联系人中过滤掉当前用户
      //       if (item.userId !== this.formData.userId) {
      //         this.parentList.push(item);
      //       }
      //     }
      //   });
      // }
    },
    changeLevel () {
      this.formData.superiorUserId = null;
    },
    fetchCardList () {
      let url = 'conf/confIdCardType/all'
      this.fetch(url).then(res => {
        this.cardList = res.data // 证件类型
      })
    },
    fetchUserMsg () {
      const _self = this
      _self.fetch('/sys/user/info/' + this.query).then(res => {
        _self.formData = res.data
        _self.defaultData = JSON.parse(JSON.stringify(res.data))
        _self.changeSchool(_self.formData.schoolId, true)
        _self.formLoading = false;
      });
    },
    // 确定回调事件
    dialogComfirm () {
      const _self = this;
      return new Promise((resolve, reject) => {
        _self.$refs['editDepartmentForm'].validate((valid) => {
          if (valid) {
            let param = Object.compare(_self.defaultData, _self.formData);
            if (_self.defaultData.userId) {
              param.userId = _self.defaultData.userId
            }
            _self.post('/sys/department/saveOrUpdate', param).then(res => {
              resolve();
            }).catch(error => {
              reject(error);
            });
          } else {
            reject(new Error());
          }
        });
      });
    }
  }
}
</script>

<style lang='less'>

</style>



// WEBPACK FOOTER //
// src/layout/dialogs/systemManage/departmentEdit.vue